<template>
  <section
    id="faq"
    class="co-bg-striped"
  >
    <div class="co-container-lg px-4 py-20">
      <h2 class="co-display-7 mb-[3.25rem] text-center">
        FAQ
      </h2>
      <div class="flex flex-col gap-x-8 md:flex-row">
        <!-- FAQ 01 -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                参加に迷っているのですが…
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <slot name="answer01">
                <p class="mb-4">
                  参加を検討されている方向けに、無料の説明会動画をご用意しています。コースの内容や習得できるスキルなどをご確認いただけます。また無料でプロのカウンセラーに相談できる無料相談もご用意しています。お気軽にご参加ください。
                </p>
                <p>
                  <a
                    href="https://ceoclone.com/kiramex-techacademy/01J68MNMXHQ184A50R2P4369N9"
                    target="_blank"
                  >サービス説明動画（無料）はこちら</a>
                  <br>
                  <a
                    class="bot_open"
                    href="/counseling/htmlcss-schedule"
                  >無料相談の詳細はこちら</a>
                </p>
              </slot>
            </div>
          </div>
        </div>
        <!-- FAQ 02 -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                他のプログラミングキャンプとの違いは？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                通常のプログラミングキャンプではカリキュラムに沿って学習していくだけですが、テックアカデミーではプロを育てるため、オリジナルサービスを開発できるレベルまでパーソナルメンターが手厚くサポートし、受講生の結果にコミットしている部分が大きく違います。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-x-8 md:flex-row">
        <!-- FAQ 03 -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                合計どのくらい学習時間が必要ですか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                現在の理解度のレベルと進捗スピードによって異なりますが、目安として合計160時間ほどの確保をお願いしております。無駄を省いた学習システムと、メンターへの質問・課題レビューで通常より短期間で成長することが可能です。
              </p>
            </div>
          </div>
        </div>
        <!-- FAQ 04 -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                期間内に学習が終わらなかったらどうなりますか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                受講終了後もカリキュラムは継続して閲覧が可能です。受講生様のオリジナルサービスの開発を出来る限りサポートとするため、追加のメンターサポート（4週間：97,900円［税込］）も合わせてご用意しております。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-x-8 md:flex-row">
        <!-- FAQ 05 -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                全くの初心者ですが問題ありませんか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                問題ありません。初心者の方でも現役のプロのメンターが全力で学習をサポートします。ただし、PCの基本的な操作が問題なくでき、期間内に必要な学習時間を確保できることが前提です。
              </p>
            </div>
          </div>
        </div>
        <!-- FAQ 06 -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                受講終了後もカリキュラムは閲覧できますか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                使用したカリキュラムは期間の制限なく継続してご覧いただけます。カリキュラムは都度アップデートしているため、最新情報で復習することが可能です。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-x-8 md:flex-row">
        <!-- FAQ 07 -->
        <div class="mb-14 basis-full md:mb-0 md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                プランの違いはなんですか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                期間の違いです。160時間の学習時間を確保できるプランをお選びください。カリキュラムやメンターサポートに違いはありません。期間中に終わらない場合の追加メンターサポートもございますが、4週間プラン終了後に4週間追加するより8週間プランをお選びいただく方がお得です。
              </p>
            </div>
          </div>
        </div>
        <!-- FAQ 08 -->
        <div class="basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                領収書や請求書の発行はできますか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                可能です。領収書はお支払い後に発行方法をご案内します。また、法人からお申し込みの場合は請求書払いも対応しています。まずはご受講される方の名前でお申し込みいただき、指定のフォームからご申請ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
